import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { createUseStyles } from 'react-jss'
import withTheme from '../styles/withTheme'
import Typography from '../Typography'

const styles = {
	link: {
		fontFamily: 'Gordita',
		fontStyle: 'normal',
		color: props => props.theme === 'dark' ? '#d8d8d8' : '#424b5a',
		textDecoration: props => props.underline ? 'underline' : 'none',
		border: 0,
		background: 'none',
		padding: 0,
		'&:hover': {
			color: '#8994a5',
			textDecoration: props => props.underline ? 'underline' : 'none'
		},
		'&:focus-visible': {
			color: '#8994a5',
			outline: 'none'
		},
		'&:disabled': {
			color: '#8994a5',
			textDecoration: props => props.underline ? 'underline' : 'none'
		}
	}
}

const useStyles = createUseStyles(styles, { name: 'Vb' })

const Link = forwardRef(function Link(props, ref) {
	const {
		className,
		component = 'a',
		underline = true,
		variant = 'inherit',
		weight,
		align,
		children,
		...other
	} = props

	const classes = useStyles(props)

	return (
		<Typography
			ref={ref}
			className={clsx(classes.link, className)}
			component={component}
			variant={variant}
			weight={weight}
			aligh={align}
			{...other}
		>
			{children}
		</Typography>
	)
})

export default withTheme('Vb-link')(Link)

Link.defaultProps = {
	component: 'a',
	underline: true
}

Link.propTypes = {
	/**
	 * The content of the component.
	 */
	children: PropTypes.node,

	/**
	 * The component used for the root node.
	 * Either a string to use a HTML element or a component.
	 * @default 'a'
	 */
	component: PropTypes.elementType,
	/**
	 * Keep or disable the default underline style for the link
	 * @default 'true'
	 */
	underline: PropTypes.bool
}
